
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ name: "RejectRequestModal" })
export default class RejectRequestModal extends Vue {
    @Prop(String) readonly title!: string;
    @Prop(String) readonly successButtonLabel!: string;
    @Prop(Function) readonly onConfirm!: (reasonId: number, comment: string) => void;

    visible: boolean = false;
    modalTitle: string = this.title ? this.title : '¿Desea cambiar a No Procesada?';
    successBtnLabel: string = this.successButtonLabel ? this.successButtonLabel : 'No Procesada';
    rejectionReasons: any[] = [];
    selectedReasonId: any = "";
    comment: string = "";

    get isOtherReason(): boolean {
        if (!this.selectedReasonId) return false;
        const reason = this.rejectionReasons.find(
            (r) => r.id === this.selectedReasonId
        );
        return reason && reason.description.toLowerCase() === "otros";
    }

    get isValid(): boolean {
        if (!this.selectedReasonId) return false;
        if (this.isOtherReason && !this.comment.trim()) return false;
        return true;
    }

    async show() {
        this.reset();
        await this.loadRejectionReasons();
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    reset() {
        this.selectedReasonId = "";
        this.comment = "";
    }

    async loadRejectionReasons() {
        if (this.rejectionReasons.length > 0) return;
        const response: any = await (this.$root as any)._get("rejectionreasons/");
        this.rejectionReasons = response.data || response;
    }

    confirm() {
        if (!this.isValid) return;
        if (this.onConfirm) {
            this.onConfirm(this.selectedReasonId, this.comment.trim());
        }
    }

    cancel() {
        this.hide();
    }
}
